import type { ReactElement } from 'react';

import { AppProviders } from './providers/AppProviders.js';

/**
 * Точка сборки приложения. Вся композиция провайдеров — в AppProviders; здесь
 * сознательно ничего больше нет, чтобы корень оставался одной строкой.
 */
export function App(): ReactElement {
  return <AppProviders />;
}
